import { getRoutesKey } from "~/helpers/search"

export default function useSubscribeAction({ routes }) {
    const [existingSubscriptions, setExistingSubscriptions] = React.useState([])
    const routesKey = getRoutesKey(routes)
    const currentRoutesIsSubscribed = existingSubscriptions.includes(routesKey)

    const { data, isSuccess } = ReactQuery.useQuery({
        queryKey: ['beard', 'items', 'subscriptions'],
        queryFn: ({ signal }) => accountAction.fetchMySubscriptions({ signal }),
        staleTime: 1000 * 60 * 5,
    })

    React.useEffect(() => {
        if (isSuccess && data) {
            setExistingSubscriptions(data.items.map(item => getRoutesKey(item.routes)))
        }
    }, [ data, isSuccess ])

    const subscribe = React.useCallback(() => {
        if (!checkAuth())
            return

        if (currentRoutesIsSubscribed)
            return

        const process = () => requestAction.subscribePlanes({ routes })
            .then(response => {
                $.fancybox.close();
                successPopup('search.subscription', () => {
                    $('body, html').animate({ scrollTop: 0 }, 500)
                    raiseEvent('showOrdersBeard', { type: 'subscriptions', fetch: true })
                })
            })
            .catch(error => {
                console.error(error)
                errorPopup(__('search.subscription.error'))
            })

        confirmPopup(__('search.subscription.agreement'), process)
    }, [ currentRoutesIsSubscribed, routes ])

    return { subscribe, currentRoutesIsSubscribed }
}
